import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import * as fromMigrations from '@migrations/state/migrations.reducer';
import {
  GetAccountMigrations,
  GetAccountMigrationProgress,
  GetMigrationReport,
} from '@migrations/state/migrations.actions';
import { Observable } from 'rxjs';
import {
  IAccountMigration,
  IMigration,
  IMigrationStatus,
  MigrationState,
} from '@shared';
import * as moment from 'moment';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MigrationDetailModalComponent } from '@migrations/components/migration-detail-modal/migration-detail-modal.component';

@Component({
  selector: 'migrations-account-detail',
  templateUrl: './migrations-account-detail.component.html',
  styleUrls: ['./migrations-account-detail.component.scss'],
})
export class MigrationsAccountDetailComponent implements OnInit {
  migrations$: Observable<IAccountMigration[]> = this.store.pipe(
    select(fromMigrations.getAccountMigrations),
  );
  isLoadingMigrations$: Observable<boolean> = this.store.pipe(
    select(fromMigrations.getMigrationsLoading),
  );
  migrationsProgress$: Observable<IMigrationStatus> = this.store.pipe(
    select(fromMigrations.getAccountMigrationProgress),
  );
  progressIsLoading$: Observable<boolean> = this.store.pipe(
    select(fromMigrations.getProgressIsLoading),
  );
  pasMigrationsProgress$: Observable<IMigration> = this.store.pipe(
    select(fromMigrations.getAccountPASMigrationProgress),
  );
  pasProgressIsLoading$: Observable<boolean> = this.store.pipe(
    select(fromMigrations.getPASProgressIsLoading),
  );

  modalRef: NgbModalRef;

  private startDate = moment()
    .subtract(3, 'months')
    .format('YYYY-MM-DDThh:mm:ssZ');

  constructor(
    private route: ActivatedRoute,
    private store: Store<fromMigrations.State>,
    private modalService: NgbModal,
  ) {}

  ngOnInit() {
    this.store.dispatch(
      new GetAccountMigrations({
        accountId: this.accountId,
        proAccountId: this.proAccountId,
        startDate: this.startDate,
      }),
    );
  }

  get accountId() {
    return this.route.snapshot.paramMap.get('accountId');
  }

  get proAccountId() {
    return this.route.snapshot.paramMap.get('proAccountId');
  }

  changeDateRange(interval) {
    const startDate = moment()
      .subtract(parseInt(interval, 10), 'months')
      .format('YYYY-MM-DDThh:mm:ssZ');
    this.store.dispatch(
      new GetAccountMigrations({
        accountId: this.accountId,
        proAccountId: this.proAccountId,
        startDate: startDate,
      }),
    );
  }

  getMigrationStateClass(state: any) {
    switch (state) {
      case MigrationState.Failed:
        return 'danger';
      case MigrationState.Success:
        return 'success';
      case MigrationState.Pending:
        return 'warning';
      case MigrationState.Running:
        return 'primary';
      case MigrationState.Submitted:
        return 'primary';
      case MigrationState.Paused:
        return 'dark';
      default:
        return '';
    }
  }

  updateMigrationProgress({ proAccountId, oneAccountId, sectionId }) {
    this.store.dispatch(
      new GetAccountMigrationProgress({
        proAccountId,
        oneAccountId,
        sectionId,
      }),
    );
  }

  openMigrationModal(migration) {
    this.modalRef = this.modalService.open(MigrationDetailModalComponent, {
      backdrop: 'static',
      keyboard: false,
    });
    const componentInstance = this.modalRef.componentInstance;

    componentInstance.migration = migration;
  }

  getMigrationReport(migration: IMigration) {
    this.store.dispatch(new GetMigrationReport(migration));
  }
}
